<div class="w-100">
  <div class="d-inline-block position-relative mw-100">
    <div #recaptchaContainer class="recaptcha-widget"></div>
  </div>
</div>
